import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as topojson from "topojson-client";
import VenueMap from "../../components/KIYG25/VenueMap";
import VenueTable from "../../components/KIYG25/VenueTable";
import Breadcrumb from "../../components/common/Breadcrumb";

export default function KIYGVenues() {
  // geoJSON data for Bihar state district wise
  // use the geojson to show as 2d map using d3.js
  const [venues, setVenues] = useState();
  const [topography, setTopography] = useState();

  useEffect(() => {
    async function fetchAndRenderMap() {
      const response = await fetch("data/bihar-coordinates.json");
      // const response = await fetch("https://gist.githubusercontent.com/hemangsk/8d4735ba288de38cf08d5da7a222f376/raw/a93d6196d6ae88ec5371667332587ebcfd49e132/india-pc.geojson");
      // use some other geojson from online url
      // const response = await fetch("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson");
      // the topojson
      // const response = await fetch("https://raw.githubusercontent.com/sssmartsearch/India_Boundary_Updated/refs/heads/master/bihar.json");
      // geojson for bihar state district wise
      const topoJSON = await response.json();
      const geoJSON = topojson.feature(topoJSON, topoJSON.objects.districts);
      setTopography(geoJSON);
      // const geoJSON = await response.json();
      // const filteredGeoJSON = {
      //     ...geoJSON,
      //     features: geoJSON.features.filter((feature) => feature.id.toLowerCase().includes("bihar"))
      // };
      console.log(geoJSON);
      // console.log(filteredGeoJSON);
      const venuesResponse = await fetch("data/kiyg25-venues.json");
      const venues = await venuesResponse.json();
      setVenues(venues);
    }

    fetchAndRenderMap();
  }, []);

  return (
    <div style={{ overflow: "auto" /* , margin:5 */ }}>
      <Breadcrumb
        pageName={KIYGVenues}
        pageTitle={"Khelo India Youth Games 2025"}
        img_url={"img/kiyg25-banner.jpg"}
        mobile_banner={"img/kiyg25-mobile.jpg"}
      />
      <Row>
        <Col>
          <br />
          <h3>Venues</h3>
          <br />
          {topography && venues && <VenueMap data={{ topography, venues }} />}
        </Col>
        <Col>
          <br />
          <h3>List</h3>
          <br />
          {venues && <VenueTable venues={venues} />}
        </Col>
      </Row>
    </div>
  );
}
